import React from 'react';
import { connect } from 'react-redux';
import fontCss from 'font-awesome/css/font-awesome.css';
import css from '../styles/home-about.css';

const { Component } = React;

class About extends Component {
  render() {
    return (
      <div className="home-about">
        <div className="home-about__image">
        </div>
        <h3 className="home-about__title">About</h3>
        <div className="home-about__info">
          <div className="home-about__info-content">
            <ul className="home-about__info-list" data-aos="zoom-in">
              <li className="home-about__info-list-item">
                <i className="fa fa-graduation-cap"></i>
                Bachelor of Arts, English Literature | <em>Baylor University 1981</em>
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-graduation-cap"></i>
                Master of Arts, English Literature | <em>Pittsburg State University 1986</em>
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-graduation-cap"></i>
                Juris Doctor | <em>Oklahoma City University School of Law, 1985</em>
              </li>
            </ul>
          </div>
          <div className="home-about__info-content">
            <ul className="home-about__info-list" data-aos="zoom-in">
              <li className="home-about__info-list-item">
                <i className="fa fa-gavel"></i>
                Member of the State Bar of Oklahoma since 1986
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-gavel"></i>
                Have practiced insurance defense, commercial litigation, employment &amp; discrimination law and commercial real estate.
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-gavel"></i>
                Have served as legal counsel to affordable housing nonprofit <em>Preservation Freehold Company</em>
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-gavel"></i>
                Have served on the Board of Advisors of an affordable housing nonprofit <em>Turning Point Ministries, Inc.</em>
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-gavel"></i>
                Served as a Barrister member of the William J. Holloway American Inn of Court | <em>1996 to 1998</em>
              </li>
              <li className="home-about__info-list-item">
                <i className="fa fa-gavel"></i>
                Member of the Oklahoma Bar Association and its Estate Planning &amp; Probate section
              </li>
            </ul>
          </div>
        </div>
        <div className="home-about__info" style="display: none;">
          <div class="home-about__info-block" data-aos="fade-right">
            <p>I grew up in a small town in the desert of southwest Texas, earned a Bachelor of Arts degree in English Literature from Baylor University in 1981, a Master of Arts degree in English Literature from Pittsburg State University in 1986, and a Juris Doctorate at Oklahoma City University in 1985.</p>
            <p>I have been a member of the State Bar of Oklahoma since 1986 and have practiced law in Oklahoma in law firms practicing insurance defense, commercial litigation, employment and discrimination law, and commercial real estate. I am admitted to practice in all Courts in and for the State of Oklahoma as well as the U.S. District Courts for the Eastern, Northern, and Western Districts of Oklahoma, and the 10 th Circuit U.S. Court of Appeals.</p>
          </div>
          <div class="home-about__info-block" data-aos="fade-left">
            <p>I have served as legal counsel to Preservation Freehold Company, an affordable housing nonprofit that helps develop affordable assisted living and senior care centers, since its formation in 2009, and since 2014 I have served as a member of the Board of Advisors of Turning Point Ministries, Inc., an affordable housing nonprofit serving Edmond, Oklahoma.</p>
            <p>From 1996 to 1998 I was a Barrister member of the William J. Holloway American Inn of Court. I am a member of the Oklahoma Bar Association and its Estate Planning and Probate Section.</p>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

let AboutContainer = connect(mapStateToProps, mapDispatchToProps)(About);

export { About, AboutContainer };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home-about.js